import { render, staticRenderFns } from "./mail-form.vue?vue&type=template&id=da6b7324&scoped=true&"
import script from "./mail-form.vue?vue&type=script&lang=js&"
export * from "./mail-form.vue?vue&type=script&lang=js&"
import style0 from "./mail-form.vue?vue&type=style&index=0&id=da6b7324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b7324",
  null
  
)

export default component.exports